export const fmtUsd = (v: number | null | undefined) =>
  v == null ? '—' : new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(v);

export const fmtArs = (v: number | null | undefined) =>
  v == null ? '—' : new Intl.NumberFormat('es-AR', { style: 'currency', currency: 'ARS' }).format(v);

export const fmtInt = (v: number | null | undefined) =>
  v == null ? '—' : new Intl.NumberFormat('es-AR').format(v);

/**
 * Canoniza la capacidad de botella ("750ml", "750 ML" → "750 ml") para que la
 * vista agrupada no separe añadas del mismo vino por diferencias de espaciado.
 * Espejo (best-effort) de App\Support\FormatNormalizer del backend.
 */
export const normalizeFormat = (format?: string | null): string => {
  if (!format) return '';
  const s = format.trim().replace(/\s+/g, ' ');
  const m = s.match(/^(\d+(?:[.,]\d+)?)\s*(ml|cc|cm3|l|lt|lts|litro|litros)?$/i);
  if (!m) return s;
  const num = parseFloat(m[1].replace(',', '.'));
  const unit = (m[2] ?? '').toLowerCase();
  const ml = ['l', 'lt', 'lts', 'litro', 'litros'].includes(unit) ? num * 1000 : num;
  return `${Math.round(ml)} ml`;
};

export const fmtDate = (iso?: string | null) => {
  if (!iso) return '—';
  const d = new Date(iso);
  return d.toLocaleDateString('es-AR', { year: 'numeric', month: '2-digit', day: '2-digit' });
};
